import React, { SVGProps } from "react";

const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg width={25} height={25} viewBox="0 0 25 25" fill="none" {...props}>
    <mask
      id="a"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={25}
      height={25}
    >
      <path fill="#D9D9D9" d="M.902.321h24v24h-24z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M10.452 18.321l-5.7-5.7 1.425-1.425 4.275 4.275 9.175-9.175 1.425 1.425-10.6 10.6z"
        fill="#fff"
      />
    </g>
  </svg>
);

export default Check;

